export class PoiId {
  constructor(
    readonly elementType: string,
    readonly elementId: number
  ) {}
}
